import { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

import { getCountry } from '@front-activerse/common-components';
import { withMobileAppMode } from '@front-activerse/common-components';
import { callNativeMobileApp } from '@front-activerse/common-components';

const FriscoButton = ({ meal, publicName, mobileApp }) => {
  const {
    consts: {
      FRISCO_FIREBASE_FUNCTION,
      FRISCO_PARTNER,
      FRISCO_DESKROP_URL_PL,
      FRISCO_DESKROP_URL_EN,
    },
    images: { friscoLogo },
  } = useAppContext();

  const { t, language } = useTranslator();

  const [preloadFrisco, setPreloadFrisco] = useState(false);

  const handleFrisco = async () => {
    const ingredients = [];

    meal.dishes.forEach((dish) => {
      dish.ingredients.forEach((ingredient) => {
        const measurement = ingredient.measurements[ingredient.measurements.length - 1];
        const measure = `${measurement.amount}${measurement.text.replace('%s', '')}`;

        ingredients.push(`${measure} ${ingredient.name}`);
      });
    });

    const request = {
      name: publicName,
      ingredients,
    };

    setPreloadFrisco(true);

    const response = await fetch(FRISCO_FIREBASE_FUNCTION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    response.json().then((data) => {
      setPreloadFrisco(false);

      if (data.friscoUrl) {
        console.log('data.friscoUrl', data.friscoUrl);
        const friscoURL = encodeURIComponent(data.friscoUrl);
        const partner = encodeURIComponent(FRISCO_PARTNER);
        const friscoDeepLink = `https://frisco.pl/go-to-app?partner=friscoach_affiliate_${partner}&jsonUrl=${friscoURL}`;

        if (mobileApp && mobileApp.os && mobileApp.os.toLowerCase().startsWith('ios')) {
          callNativeMobileApp({
            action: 'deeplink_open',
            payload: {
              url: friscoDeepLink,
            },
          });
        } else {
          window.location = friscoDeepLink;
        }
      }
    });
  };

  const urlMap = {
    'en-US': FRISCO_DESKROP_URL_EN,
    'pl-PL': FRISCO_DESKROP_URL_PL,
  };

  if (getCountry() === 'Poland') {
    return (
      <div className="text-center">
        <Button
          color="frisco"
          className="d-md-none"
          onClick={handleFrisco}
          disabled={preloadFrisco}
        >
          {t('orderIngredients.frisco.button')}{' '}
          <img
            src={friscoLogo}
            style={{
              verticalAlign: 'baseline',
              height: '16px',
            }}
            alt="instacart"
          />
        </Button>
        <a
          href={urlMap[language]}
          className="d-none d-md-inline-block btn btn-frisco w-auto"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('orderIngredients.frisco.button')}{' '}
          <img
            src={friscoLogo}
            style={{
              verticalAlign: 'baseline',
              height: '16px',
            }}
            alt="instacart"
          />
        </a>
      </div>
    );
  }

  return null;
};

export default withMobileAppMode(FriscoButton);
